import { connect, Summary } from '../dependencies';
import { summarySelector } from '../services/selectors';

const mapStateToProps = summarySelector;

export default connect(mapStateToProps)(Summary);
